// Nome do registro aberto no breadcrumb da barra superior. O Layout monta a trilha pela URL e não
// conhece o nome (ex.: do parceiro); a página publica aqui e o Layout troca o rótulo genérico
// ("Detalhes do parceiro") pelo nome. Mesmo padrão de pageFiltersService.
export const BREADCRUMB_ENTITY_EVENT = "flamex:breadcrumb-entity";

// path: rota do registro ("/parceiros/1799"). O Layout só usa o nome se o path bater com a URL
// atual, então um nome antigo nunca aparece em outro parceiro enquanto o novo carrega.
// Guardado porque a página (filho) publica antes de o Layout (pai) começar a escutar.
let lastEntity = { path: "", label: "" };

function dispatch(detail) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(BREADCRUMB_ENTITY_EVENT, { detail }));
}

export function getBreadcrumbEntity() {
  return lastEntity;
}

export function publishBreadcrumbEntity({ path, label }) {
  lastEntity = { path: String(path || ""), label: String(label || "") };
  dispatch(lastEntity);
}

export function clearBreadcrumbEntity() {
  lastEntity = { path: "", label: "" };
  dispatch(lastEntity);
}
